import { render, staticRenderFns } from "./configSelectDialog.vue?vue&type=template&id=3351f05b&scoped=true&"
import script from "./configSelectDialog.vue?vue&type=script&lang=js&"
export * from "./configSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./configSelectDialog.vue?vue&type=style&index=0&id=3351f05b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351f05b",
  null
  
)

export default component.exports